export function redirectToCrmDashboard(): void {
  window.location.replace("/react/dashboard");
}
